import {SvgIcon, SvgIconProps} from "@mui/material";

export default function CreditCard(props: SvgIconProps) {
        const {viewBox, ...restProps} = props;
    return (
        <SvgIcon {...restProps} viewBox={'0 0 40.09 40.09'}>
         
                <path d="M13.045,14.676A7.338,7.338,0,1,0,5.707,7.338,7.34,7.34,0,0,0,13.045,14.676Zm6.523,1.631H16.76a8.87,8.87,0,0,1-7.43,0H6.523A6.522,6.522,0,0,0,0,22.829v.815A2.447,2.447,0,0,0,2.446,26.09h21.2a2.447,2.447,0,0,0,2.446-2.446v-.815A6.522,6.522,0,0,0,19.568,16.306Z" 
                      transform="translate(7 7)" fill="none" stroke="currentColor" strokeWidth="2"/>
           
        </SvgIcon>
    );
}